import * as React from 'react';

import * as styles from './BannersRow.css';
import { Layout } from '../Layout';

export const BannersRow: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <Layout>
      <div className={styles['row']} data-testid="BannersRow">
        {children}
      </div>
    </Layout>
  );
};
